const {
    EVENT_CATEGORY_NAMES,
    EVENT_LABELS,
    GTM_EVENTS,
} = require('app_byl_core/analytics/analyticsConst');
const { onOnce } = require('app_byl_core/common/utils/domEvents');

const EVENT_ACTION = 'Dia de la madre';

function pushEvent(label) {
    const EVENT_DATA = {
        event: GTM_EVENTS.eventGA,
        category: EVENT_CATEGORY_NAMES.interaction,
        action: EVENT_ACTION,
    };

    dataLayer.push({
        ...EVENT_DATA,
        label,
    });
}

function trackFormSubmit() {
    pushEvent(EVENT_LABELS.send);
}

function trackHomeModalRedirectClick() {
    pushEvent(EVENT_LABELS.homePopup);
}

function trackModalRedirectClick() {
    pushEvent(EVENT_LABELS.popup);
}

function trackDownloadClick() {
    pushEvent(EVENT_LABELS.download);
}

function init() {
    const homeModalLink = document.querySelector(
        '.mothers-day-home-modal__link'
    );
    const modalLink = document.querySelector(
        '.mothers-day-confirmation-modal__link'
    );
    const downloadLink = document.querySelector(
        '.mothers-day-landing-form__download-link'
    );
    if (homeModalLink) {
        homeModalLink.addEventListener('click', trackHomeModalRedirectClick);
    }
    if (modalLink) {
        modalLink.addEventListener('click', trackModalRedirectClick);
    }
    if (downloadLink) {
        downloadLink.addEventListener('click', trackDownloadClick);
    }
    document.addEventListener('mothers-day:submit', trackFormSubmit);

    onOnce(window, 'beforeunload', () => {
        if (homeModalLink) {
            homeModalLink.removeEventListener(
                'click',
                trackHomeModalRedirectClick
            );
        }
        if (modalLink) {
            modalLink.removeEventListener('click', trackModalRedirectClick);
        }
        if (downloadLink) {
            downloadLink.removeEventListener('click', trackDownloadClick);
        }
        document.removeEventListener('mothers-day:submit', trackFormSubmit);
    });
}

init();
